import React from 'react';
import './contact-details-form-skeleton.scss';

const ContactDetailsFormSkeleton: React.FC = () => {
    return (
        <div
            className="osb-v3-contact-details-skeleton-form"
            data-testid="contact-details-form-skeleton"
        >
            <div className="osb-v3-contact-details-skeleton-form__input">
                <form>
                    <div className="osb-v3-contact-details-form-skeleton-form-group">
                        <div className="osb-v3-contact-details-form-skeleton osb-v3-contact-details-form-skeleton-label"></div>
                        <div className="osb-v3-contact-details-form-skeleton osb-v3-contact-details-form-skeleton-input"></div>
                    </div>

                    <div className="osb-v3-contact-details-form-skeleton-form-group">
                        <div className="osb-v3-contact-details-form-skeleton osb-v3-contact-details-form-skeleton-label"></div>
                        <div className="osb-v3-contact-details-form-skeleton osb-v3-contact-details-form-skeleton-input"></div>
                    </div>

                    <div className="osb-v3-contact-details-form-skeleton-form-group">
                        <div className="osb-v3-contact-details-form-skeleton osb-v3-contact-details-form-skeleton-label"></div>
                        <div className="osb-v3-contact-details-form-skeleton osb-v3-contact-details-form-skeleton-input"></div>
                    </div>

                    <div className="osb-v3-contact-details-form-skeleton-form-row">
                        <div className="osb-v3-contact-details-form-skeleton-form-group osb-v3-contact-details-form-skeleton-contact-group">
                            <div className="osb-v3-contact-details-form-skeleton osb-v3-contact-details-form-skeleton-label"></div>
                            <div className="osb-v3-contact-details-form-skeleton osb-v3-contact-details-form-skeleton-input"></div>
                        </div>
                        <div className="osb-v3-contact-details-form-skeleton-form-group">
                            <div className="osb-v3-contact-details-form-skeleton osb-v3-contact-details-form-skeleton-label"></div>
                            <div className="osb-v3-contact-details-form-skeleton osb-v3-contact-details-form-skeleton-input"></div>
                        </div>
                    </div>

                    <div className="osb-v3-contact-details-form-skeleton-form-group">
                        <div className="osb-v3-contact-details-form-skeleton osb-v3-contact-details-form-skeleton-label"></div>
                        <div className="osb-v3-contact-details-form-skeleton osb-v3-contact-details-form-skeleton-input"></div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ContactDetailsFormSkeleton;
